import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";
import "../../styles/index.css";
import HeroPromo from "./components/HeroPromo";
import PromoGrid from "./components/PromoGrid";

const PromoPage = () => {
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/promos/index.php")
      .then((res) => res.json())
      .then((data) => {
        // backend kita return ARRAY
        if (Array.isArray(data)) {
          setPromos(data);
        } else if (Array.isArray(data.data)) {
          setPromos(data.data);
        } else {
          setPromos([]);
        }
      })
      .catch((err) => {
        console.error("FETCH PROMO PUBLIK ERROR:", err);
        setPromos([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>Promo Honda Motor</title>
        <meta
          name="description"
          content="Dapatkan promo terbaik untuk motor Honda. DP ringan, cicilan murah, dan bonus menarik menanti Anda!"
        />
      </Helmet>

      <Header />

      <main>
        <HeroPromo />
        <PromoGrid promos={promos} loading={loading} />
      </main>



      <Footer />
    </>
  );
};

export default PromoPage;
